import { ValidationError } from '@oysterjs/core/graphql';
import { LoggedInAgencyUserFieldsFragment } from '~/api/graphql';
import { VoiceAgentSettingsFormInput } from './voice_agent_form_input';
import {
  filterVoiceOptions,
  type LanguageOption,
  type VoiceAgentLanguageSupportData
} from './voice_language_support';

export const getVoiceAgentAgencyPlaceholders = (
  agencyUser: LoggedInAgencyUserFieldsFragment
): VoiceAgentAgencyPlaceholders => {
  const { agency } = agencyUser;
  const mailingAddress = agency.mailingAddress;
  const mailingAddressPlaceholder = [
    mailingAddress.line1,
    mailingAddress.line2,
    `${mailingAddress.city}, ${mailingAddress.zone} ${mailingAddress.postalCode}`
  ]
    .filter(Boolean)
    .join('\n');

  return {
    agencyName: agency.name,
    contactPhone:
      agency.configuration.liabilityCOIConfiguration.contactPhone || '+1 (555) 123-4567',
    contactEmail:
      agency.configuration.liabilityCOIConfiguration.contactEmail || 'contact@agency.com',
    mailingAddressPlaceholder
  };
};

export type VoiceAgentAgencyPlaceholders = {
  agencyName: string;
  contactPhone: string;
  contactEmail: string;
  mailingAddressPlaceholder: string;
};

export type VoiceAgentFormSectionProps = {
  form: VoiceAgentSettingsFormInput;
  phoneNumber: string;
  agencyPlaceholders: VoiceAgentAgencyPlaceholders;
  validationErrors: ValidationError[];
  getFieldId: (path: string[]) => string;
  getValidationError: (errors: ValidationError[], path: string[]) => string | undefined;
  updateForm: (
    path: string[],
    updater: (prev: VoiceAgentSettingsFormInput) => VoiceAgentSettingsFormInput
  ) => void;
  filteredVoiceOptions: ReturnType<typeof filterVoiceOptions>;
  filteredLanguageOptions: LanguageOption[];
  languageSupport: VoiceAgentLanguageSupportData;
  hasAdvancedCustomization?: boolean;
  isOutboundVoice?: boolean;
  supportsMultipleLanguages?: boolean;
  voice35Enabled?: boolean;
  /** Locked outbound intro disclosure from the API; only set for outbound agents. */
  outboundIntroComplianceDisclosure?: string | null;
};
